import {makeStyles} from '@material-ui/core'
const useStyles = makeStyles(theme => ({
  imageBox: {
    height: '2.8rem',
    width: '99%',
    'background-color': '#f5f5f5',
    border: '1px solid #dfdfdf',
  },
  marginLeft: {
    marginLeft: '10px',
    height: '2.8rem',
    width: '99%',
    'background-color': '#f5f5f5',
    border: '1px solid #dfdfdf',
  },
  marginRight: {
    marginRight: '10px',
    height: '2.8rem',
    width: '99%',
    'background-color': '#f5f5f5',
    border: '1px solid #dfdfdf',
  },
  imageQRSize: {
    display: 'block',
    margin: '5px auto',
    width: '2rem',
  },
  imageSize: {
    display: 'block',
    margin: '5px auto',
    width: '5rem',
    height: '65%',
  },
  textSize: {
    fontSize: '0.8rem',
    textAlign: 'center',
    padding: '11px 0',
  },
  textField: {
    marginBottom: 35,
    width: '100%',
  },
  dragItem: {
    width: '100%',
  },
  menuBar: {
    marginBottom: 30,
  },
  fontSize: {
    marginLeft: '14px',
    fontSize: '0.7rem',
  },
}))

export default useStyles
